@if (latestConnection$ | async; as latestConnection) {
    <adapt-dashboard-element name="Lumia access">
        @if (!latestConnection.hasAccess) {
            <div class="badge bg-danger"
                 adaptTooltip="Set the ability for this person to log in from page menu or on the 'Configuration' -> 'Manage People' page">
                <i class="fal fa-user-times pe-1"></i>Login disallowed
            </div>
        }
        @if (latestConnection.hasAccess && latestConnection.startDate > today) {
            <div class="badge bg-warning"
                 adaptTooltip="The user will be allowed to login from their start date"><i class="fal fa-user-times pe-1"></i>Login Pending
            </div>
        }
        @if (latestConnection.hasAccess && latestConnection.startDate <= today) {
            <div class="badge bg-success"
                 adaptTooltip="Set the ability for this person to log in from page menu or on the 'Configuration' -> 'Manage People' page">
                <i class="fal fa-user-times pe-1"></i>Login allowed
            </div>
        }
        <button class="btn"
                (click)="showDetails = !showDetails"
                data-test="show-access-details">
            <i class="key-result-chevron"
               [ngClass]="chevronIconClass"></i>
        </button>
        @if (showDetails) {
            <div>
                <h3 class="mt-2">User type</h3>
                <strong>{{ userTypeLabel$ | async }}</strong>: {{ userTypeInfo$ | async }}
                <ng-container *adaptLoadingUntilFirstEmit="let roleConnections of roleConnections$">
                    @if (roleConnections.organisation.length > 0) {
                        <h3 class="mt-2">Organisation access levels</h3>
                        @for (roleConnections of roleConnections.organisation; track roleConnections) {
                            <div>
                                <adapt-link-access-level [role]="roleConnections.role"></adapt-link-access-level>
                            </div>
                        }
                    }
                    @if (roleConnections.team.length > 0) {
                        <h3 class="mt-2">Team access levels</h3>
                        @for (roleConnections of roleConnections.team; track roleConnections) {
                            <div>
                                <adapt-link-access-level [role]="roleConnections.role"
                                                         [adaptLinkDisabled]="true"></adapt-link-access-level>
                            </div>
                        }
                    }
                    @if (roleConnections.organisation.length === 0 && roleConnections.team.length === 0) {
                        <h3 class="mt-2">Access levels</h3>
                        This person has not been granted any access to Lumia
                    }
                </ng-container>
                <ng-container *adaptLoadingUntilFirstEmit="let inviteDate of inviteDate$">
                    @if (inviteDate) {
                        <h3 class="mt-2">Platform invite date</h3>
                        {{ inviteDate | adaptDate }}
                    }
                </ng-container>
            </div>
        }
    </adapt-dashboard-element>
}
